import { useEffect, useState } from 'react';

import { useFlagIsActivated } from '../../hooks/featureFlag';
import { GROW_SHOW_GOOGLE_ONE_TAP } from '../../../../shared/constants/featureFlag';

function usePromptGoogleOneTapLogin() {
  const [prompted, setPrompted] = useState(false);

  const showPrompt = useFlagIsActivated({
    flag: GROW_SHOW_GOOGLE_ONE_TAP,
    activationValues: ['show-new'],
  });

  useEffect(() => {
    if (showPrompt === undefined || prompted) {
      return;
    }

    if (showPrompt) {
      setPrompted(true);
      window?.google?.accounts?.id?.prompt();
    }
  }, [showPrompt, prompted]);
}

const GoogleOneTap = () => {
  usePromptGoogleOneTapLogin();

  return null;
};

export default GoogleOneTap;
